define('wizard_module.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('wizard_module', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/SignalGroup/SignalGroupSearchSpringTheme/24.2.10/', 'extensions/SignalGroup/SignalGroupSearchSpringTheme/24.2.10/', Handlebars);
});